__turbopack_context__.v({
  "buttons": "ConfirmationForm-module-scss-module__NFABJa__buttons",
  "cancel-button": "ConfirmationForm-module-scss-module__NFABJa__cancel-button",
  "confirm": "ConfirmationForm-module-scss-module__NFABJa__confirm",
  "permanence-warning": "ConfirmationForm-module-scss-module__NFABJa__permanence-warning",
  "subdomain": "ConfirmationForm-module-scss-module__NFABJa__subdomain",
});
